module.exports = __webpack_public_path__ + "static/media/anim-5-update.6ee78b2b.png";